import { Modal } from 'antd';
import React from 'react';
import { ModalFuncProps } from 'antd/es/modal/interface';
import { ModalStaticFunctions } from 'antd/es/modal/confirm';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { HookAPI } from 'antd/es/modal/useModal';

import styles from './index.module.scss';

export interface UseSimpleModalProps extends ModalFuncProps {
  contentH2?: string
  contentSpan?: string
}

interface UseSimpleModal {
  // open: (props?: UseSimpleModalProps) => void
  open: HookAPI['confirm'] & UseSimpleModalProps
  modal: Omit<ModalStaticFunctions, 'warn'>
  contextHolder: React.ReactElement
}

export function useSimpleModal(initProps?: UseSimpleModalProps): UseSimpleModal {
  const [modal, contextHolder] = Modal.useModal();

  return {
    open: (props?: UseSimpleModalProps) => modal.confirm({
      className: styles.modal,
      title: 'Confirm',
      ...initProps,
      ...props,
      icon: <ExclamationCircleOutlined style={{ color: '#FAAD14', fontSize: 20 }} />,
    }),
    modal,
    contextHolder,
  };
}

interface SimpleModalProps extends UseSimpleModalProps {
  open: boolean;
}

export default function SimpleModal(initProps: SimpleModalProps) {
  const { contextHolder } = useSimpleModal(initProps);

  return contextHolder;
}
